import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { getCameraDisplayName, getCameraKeyString, getSiteString } from "@src/utils/key-parser";

export function filterCamerasByQuery(cameras: CameraApiResponse[], query: string): CameraApiResponse[] {
  const normalized = query.toLowerCase().trim();
  if (!normalized) return cameras;

  return cameras.filter((camera) => {
    const cameraKey = getCameraKeyString(camera).toLowerCase();
    const site = getSiteString(camera).toLowerCase();
    const displayName = (camera.name || getCameraDisplayName(cameraKey))?.toLowerCase() ?? "";
    const nickname = camera.nickname?.toLowerCase() ?? "";
    const name = camera.name?.toLowerCase() ?? "";

    return (
      cameraKey.includes(normalized) ||
      site.includes(normalized) ||
      displayName.includes(normalized) ||
      nickname.includes(normalized) ||
      name.includes(normalized)
    );
  });
}
